import React, { SyntheticEvent, useEffect, useState } from 'react';
import './home.scss';
import appInfo from '../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import { useAuth } from "../../contexts/AuthContext";

import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import MsiPieChart from '../../components/custom/MsiPieChart';
import MsiChart from '../../components/custom/MsiChart';

import { complaintsData } from '../../sample-data/example-chart';
import { splineData, seriesTypeLabel } from "../../sample-data/example-spline";
import MsiSplineChart from '../../components/custom/MsiSplineChart';
import Swal from 'sweetalert2';

// ** Third Party Imports
import axios from 'axios'
import apiUrl from '../../configs/constant';

import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import MuiTabList, { TabListProps } from '@mui/lab/TabList'
import TabList from '@mui/lab/TabList';
import OrgStructure from '../../components/chart/organization-structure';


// Styled Grid component
const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    order: -1,
    display: 'flex',
    justifyContent: 'center'
  }
}))

// Styled component for the image
const Img = styled('img')(({ theme }) => ({
  right: 10,
  bottom: 35,
  width: 100,
  position: 'absolute',
  [theme.breakpoints.down('sm')]: {
    width: 200,
    position: 'static'
  }
}))


const divStyle = {
  overflowX: 'visible' as const,
  overflowY: 'scroll' as const,
  position: 'relative' as const
}

export default function Home() {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user')!)
  const user = userData.data
  const storedToken = userData.token

  const dataSource = [{
    label: 'USA',
    value: 110,
  }, {
    label: 'China',
    value: 100,
  }, {
    label: 'Russia',
    value: 72,
  }, {
    label: 'Britain',
    value: 47,
  }, {
    label: 'Australia',
    value: 46,
  }, {
    label: 'Germany',
    value: 41,
  }, {
    label: 'France',
    value: 40,
  }, {
    label: 'Indonesia',
    value: 50,
  }];

  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "1"; // Default ke tab 1

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12}>
        <div className={'content-block dx-card responsive-paddings'} style={{ position: 'relative' }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Typography variant='h5' sx={{ mb: 4.5 }}>
                Welcome to {appInfo.title} App,{' '}
                <Box component='span' sx={{ fontWeight: 'bold' }}>
                  {user.id}
                </Box>
              </Typography>
              <Typography variant='body2'>
                Personalized Souvenirs Make Every Celebration Unforgettable
                {/* <Box component='span' sx={{ color: 'error.main' }}>
                ❤️
              </Box> */}
              </Typography>
            </Grid>
            <StyledGrid item xs={12} sm={6}>
              <Img alt={appInfo.title} src={appInfo.logo} />
            </StyledGrid>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12} sm={6}>
        <div className={'content-block dx-card responsive-paddings'} style={{ position: 'relative' }}>
          <MsiPieChart data={dataSource} title='Pie Charts' />
        </div>
      </Grid>
      <Grid item xs={12} sm={6}>
        <div className={'content-block dx-card responsive-paddings'} style={{ position: 'relative' }}>
          <MsiChart title='Chart' array={complaintsData} />
        </div>
      </Grid>
      <Grid item xs={12} sm={6}>
        <div className={'content-block dx-card responsive-paddings'} style={{ position: 'relative' }}>
          <MsiSplineChart title='Spline Area' array={splineData} />
        </div>
      </Grid>
    </Grid>
  )
}

